import React from 'react';

import {
  getEngagementPackagesMockData,
  getThemeArtMockData,
  getTrafficDetailsMockData,
  getTrafficPackagesMockData,
} from '../mockData';
import {
  ConfiguratorEngagementPackage,
  ConfiguratorThemeArtOption,
  ConfiguratorThemeDesignOption,
  ConfiguratorTrafficDetails,
  ConfiguratorTrafficPackage,
} from '../types';
import { requestConfiguratorConfig } from '../utils/api';
import { getInitialTrafficDetailsState } from '../utils/state';

export function useConfigFetch() {
  const [configDesignOptions, setConfigDesignOptions] = React.useState<ConfiguratorThemeDesignOption[]>([]);
  const [configArtOptions, setConfigArtOptions] = React.useState<ConfiguratorThemeArtOption[]>([]);
  const [configEngagementPackages, setConfigEngagementPackages] = React.useState<ConfiguratorEngagementPackage[]>([]);
  const [configTrafficDetails, setConfigTrafficDetails] = React.useState<ConfiguratorTrafficDetails>(getInitialTrafficDetailsState());
  const [configTrafficPackages, setConfigTrafficPackages] = React.useState<ConfiguratorTrafficPackage[]>([]);
  const [configLoading, setConfigLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    Promise.all([
      requestConfiguratorConfig(),
      getThemeArtMockData(),
      getEngagementPackagesMockData(),
      getTrafficDetailsMockData(),
      getTrafficPackagesMockData(),
    ]).then(([config, themeArts, engagementPackages, trafficDetails, trafficPackages]) => {
      setConfigDesignOptions(config.designVariants);
      setConfigArtOptions(themeArts);
      setConfigEngagementPackages(engagementPackages);
      setConfigTrafficDetails(trafficDetails);
      setConfigTrafficPackages(trafficPackages);

      setConfigLoading(false);
    });
  }, []);

  return React.useMemo(
    () => ({
      configDesignOptions,
      configArtOptions,
      configEngagementPackages,
      configTrafficDetails,
      configTrafficPackages,
      configLoading,
    }),
    [
      configDesignOptions,
      configArtOptions,
      configEngagementPackages,
      configTrafficDetails,
      configTrafficPackages,
      configLoading,
    ],
  );
}
